import 'Scripts/ContentBox-4.1.1/assets/minimalist-blocks/content.scss';
import 'Scripts/ContentBox-4.1.1/box/box.js';
import 'Scripts/ContentBox-4.1.1/box/box.scss';

if (WCC.isIE)
    require('Scripts/ContentBox-4.1.1/box/box-ie.scss');